import React, { useContext, useEffect } from 'react';
import { startLoading, stopLoading } from '../../../api/CommonApi';
import { useCommon } from '../../../contexts/CommonContext';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { DailyEngagedUserContainer } from '../styles';
import CompiledDailyEngagedUsers from './CompiledDailyEngagedUsers';
import DailyEngagedUserMonthlyUsage from './DailyEngagedUserMonthlyUsage';
import DailyEngagedUserUsage from './DailyEngagedUserUsage';

const DailyEngagedUsersSummaryComponent: React.FC = () => {
  const { tenant, content } = useContext(DailyEngagedUsersContext);
  const { setHeaderContent } = useCommon();

  useEffect(() => {
    startLoading();
    setHeaderContent({
      redirect: '/',
      text: content.formatString(content.header, tenant.info.name),
    });

    stopLoading();

    return () => setHeaderContent({ redirect: null });
  }, []);

  return (
    <DailyEngagedUserContainer>
      <CompiledDailyEngagedUsers></CompiledDailyEngagedUsers>
      <DailyEngagedUserMonthlyUsage tableBodyHeight="1000px" registersToTake={5}></DailyEngagedUserMonthlyUsage>
      <DailyEngagedUserUsage tableBodyHeight="1000px" registersToTake={5}></DailyEngagedUserUsage>
    </DailyEngagedUserContainer>
  );
};

export default DailyEngagedUsersSummaryComponent;
